import { CarouselApi } from "@/components/ui/carousel";
import { ImageNavigation, DotsNavigation } from "./type";
import NumberNavigation from "./type/single-indicator/NumberNavigation";

const PaginationStyleSelector = ({
  navigationType,
  currentIndex,
  carouselApi,
  imgSrc,
  index,
}: {
  navigationType: "image" | "dots" | "number";
  currentIndex: number;
  carouselApi: CarouselApi;
  imgSrc: string[];
  index: number;
}) => {
  if (carouselApi?.slideNodes().length === 1) return null;
  switch (navigationType) {
    case "image":
      return (
        <ImageNavigation
          index={index}
          currentIndex={currentIndex}
          carouselApi={carouselApi}
          imgSrc={imgSrc[index]}
        />
      );
    case "number":
      return (
        <NumberNavigation
          currentIndex={currentIndex}
          carouselApi={carouselApi}
          index={index}
        />
      );
    default:
      return (
        <DotsNavigation
          currentIndex={currentIndex}
          carouselApi={carouselApi}
          index={index}
        />
      );
  }
};

export default PaginationStyleSelector;
